/******/ (() => { // webpackBootstrap
/******/ 	"use strict";
/*!***********************************************!*\
  !*** ./js/sections/collection-list-slider.js ***!
  \***********************************************/
/* unused harmony default export */ var __WEBPACK_DEFAULT_EXPORT__ = (() => {
  if (!customElements.get('collection-list-slider')) {
    customElements.define('collection-list-slider', class CollectionLogosSlider extends HTMLElement {
      constructor() {
        super();
      }
      connectedCallback() {
        this.selectors = {
          sliderWrapper: '.brand-logos__items',
          nextEl: '.swiper-button-next',
          prevEl: '.swiper-button-prev',
          pagination: '.swiper-pagination'
        };
        this.classes = {
          grid: 'f-grid',
          swiper: 'swiper',
          swiperWrapper: 'swiper-wrapper'
        };
        this.container = this.closest('.brand-logos__container');
        this.sectionContent = this.closest('.section__content');
        this.sliderWrapper = this.querySelector(this.selectors.sliderWrapper);
        this.enableSlider = this.dataset.enableSlider === 'true';
        this.items = parseFloat(this.dataset.items) || 6;
        this.tabletItems = parseInt(this.dataset.tabletItems) || 3;
        this.laptopItems = parseInt(this.dataset.laptopItems) || 5;
        this.itemSize = this.dataset.itemSize || 'auto';
        this.columnsDesktop = parseInt(this.dataset.columnsDesktop, 10) || 6;
        this.columnsMobile = parseFloat(this.dataset.columnsMobile) || 2.5;
        this.navigationPosition = this.dataset.navigationPosition || 'middle';
        this.sliderInstance = false;
        if (!this.enableSlider) return;
        this.initSlider();
      }
      initSlider() {
        if (typeof this.sliderInstance === 'object') return;
        var columnGap = (window.getComputedStyle(this.sliderWrapper).getPropertyValue('--f-column-gap') || '').trim();
        var spaceBetween = 0;
        if (columnGap) {
          var val = parseFloat(columnGap);
          if (!isNaN(val)) {
            var rootFontSize = parseFloat(window.getComputedStyle(document.documentElement).fontSize) || 16;
            if (columnGap.includes('rem')) spaceBetween = val * rootFontSize;else if (columnGap.includes('px')) spaceBetween = val;
          }
        }
        var dataSpace = this.dataset.spaceBetween;
        if (dataSpace !== undefined && dataSpace !== '') spaceBetween = parseFloat(dataSpace) || spaceBetween;

        // Look for controls in section__content (parent of brand-logos__container)
        var controlsContainer = this.sectionContent || this.container;
        var useFixedSize = this.itemSize === 'fixed';
        var mobileSlides = useFixedSize ? this.columnsMobile : 2;
        var tabletSlides = useFixedSize ? Math.min(4, this.columnsDesktop) : this.tabletItems;
        var laptopSlides = useFixedSize ? this.columnsDesktop > 6 ? this.columnsDesktop - 1 : this.columnsDesktop : this.laptopItems;
        var desktopSlides = useFixedSize ? this.columnsDesktop : this.items;
        this.sliderOptions = {
          slidesPerView: mobileSlides,
          spaceBetween: 16,
          slidesOffsetAfter: 32,
          navigation: {
            nextEl: controlsContainer.querySelector(this.selectors.nextEl),
            prevEl: controlsContainer.querySelector(this.selectors.prevEl)
          },
          pagination: {
            el: controlsContainer.querySelector(this.selectors.pagination),
            type: 'progressbar'
          },
          breakpoints: {
            768: {
              slidesPerView: tabletSlides
            },
            1024: {
              slidesPerView: laptopSlides
            },
            1280: {
              slidesPerView: desktopSlides
            }
          },
          loop: false,
          threshold: 2,
          watchSlidesProgress: true
        };
        this.classList.add(this.classes.swiper);
        this.sliderWrapper.classList.remove(this.classes.grid);
        this.sliderWrapper.classList.add(this.classes.swiperWrapper);
        this.sliderInstance = new window.FoxTheme.Carousel(this, this.sliderOptions);
        this.sliderInstance.init();
      }
      destroySlider() {
        this.classList.remove(this.classes.swiper);
        this.sliderWrapper.classList.remove(this.classes.swiperWrapper);
        this.sliderWrapper.classList.add(this.classes.grid);
        if (typeof this.sliderInstance !== 'object') return;
        this.sliderInstance.slider.destroy();
        this.sliderInstance = false;
      }
    });
  }
});
/******/ })()
;